var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h14v14H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9B0BD",
    fillRule: "nonzero",
    d: "M7.418 4.833 6 .167 4.582 4.833H.167l3.605 2.573L2.4 11.833 6 9.097l3.605 2.736-1.37-4.427 3.598-2.573z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyStar);
export default __webpack_public_path__ + "static/media/grey-star.48467d82ac3d26daecda349cd81e1e83.svg";
export { ForwardRef as ReactComponent };